module.exports = __webpack_public_path__ + "static/media/Coffee_in_Cambodia_credit_Getty_Images_mobile.fbdad9b8.jpg";